import React from 'react'

import {
  Box,
  Divider,
  ListItem,
  ListItemIcon,
  ListItemText,
  Paper,
  Typography,
  useTheme
} from '@material-ui/core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faFile,
  faFileExcel,
  faFileImage,
  faFilePdf,
  faFilePowerpoint,
  faFileWord
} from '@fortawesome/free-regular-svg-icons'

const FileMessage = ({ file, onFileClick }) => {
  return (
    <>
      <ListItem component={Paper} elevation={0} button onClick={onFileClick}>
        <ListItemIcon>
          <Box p={1}>
            <FileIcon fileType={file.file_type} />
          </Box>
        </ListItemIcon>
        <ListItemText>
          <Typography variant={'body1'}>{file.file_name}</Typography>
          <Typography variant={'caption'}>{file.file_size}</Typography>
        </ListItemText>
      </ListItem>
      <Divider />
    </>
  )
}

const FileIcon = ({ fileType }) => {
  const theme = useTheme()
  let iconConfigs = {
    icon: faFile,
    size: '2x'
  }

  switch (fileType) {
    case 'pdf':
      iconConfigs = {
        ...iconConfigs,
        icon: faFilePdf,
        color: theme.palette.secondary.main
      }
      break
    case 'docs':
      iconConfigs = {
        ...iconConfigs,
        icon: faFileWord,
        color: theme.palette.info.dark
      }
      break
    case 'excel':
      iconConfigs = {
        ...iconConfigs,
        icon: faFileExcel,
        color: theme.palette.success.main
      }
      break
    case 'powerpoint':
      iconConfigs = {
        ...iconConfigs,
        icon: faFilePowerpoint,
        color: theme.palette.error.dark
      }
      break
    case 'image':
      iconConfigs = {
        ...iconConfigs,
        icon: faFileImage,
        color: theme.palette.text.hint
      }
      break
    case 'other':
    default:
      break
  }
  return <FontAwesomeIcon {...iconConfigs} />
}
export default FileMessage
